/** @jsx jsx */
// Please keep this import for Emotion CSS to load properly
import { jsx } from "@emotion/react";
import React from "react";
import { formatAmount } from "../../../Utils/formatAmount";
import { tableCell, tableHeader, tableRow } from "../../../styles/tableStyles";
import CompanyAddress from "../../../Utils/CompanyAddress";
import CompanyAddresslogo from "../../../Utils/CompanyAddresslogo";

const headData = [
  { value: "Product" },
  { value: "Batch#" },
  { value: "Quantity" },
  { value: "Rate" },
  { value: "Amount" },
];

const CustomerDebtorPrint = ({ invoices = [], customer = {} }) => {
    const customerName = customer.name || "N/A"; // fallback
  return (

    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        width: "100%",
        boxSizing: "border-box",
      }}
    >


      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
      <CompanyAddresslogo />
        Customer Debtor Report
      </h2>

      <div style={{ marginBottom: "16px" }}>
        <p>
          <strong>Customer Name:</strong> {customer.name}
        </p>
      </div>

      {invoices.map((invoice, index) => (
        <div
          key={invoice.id || index}
          style={{
            marginBottom: "30px",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "4px",
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <p>
              <strong>Invoice #: </strong> {invoice.invoice_number}
            </p>
            <p>
              <strong>Purchase Date: </strong>{" "}
              {invoice.date ? invoice.date : ""}
            </p>
          </div>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "10px",
            }}
          >
            <thead>
              <tr>
                {headData.map((head) => (
                  <th
                    key={head.value}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "left",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    {head.value}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoice.products?.map((product, idx) => (
                <tr key={idx}>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {product.product_name}
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {product.batch_id}
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {product.quantity}
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {product.rate}
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {formatAmount(product.quantity * product.rate)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ textAlign: "right" }}>
            <p>
              <strong>Total Amount:</strong>{" "}
              {formatAmount(invoice.total_amount || 0)}
            </p>
            <p>
              <strong>Payment Received:</strong>{" "}
              {formatAmount(invoice.paid_amount || 0)}
            </p>
            <p>
              <strong>Amount Due:</strong>{" "}
              {formatAmount(invoice.due_amount || invoice.total_amount || 0)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export { CustomerDebtorPrint };
